'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { REGISTER_STATUS_BAR } from 'DesignData/actions/ActionTypes';
/**
 * SHAPE
 *
 * {
 *   codemirrorSessionId: number
 *   codemirrorType: codemirror mode
 *   activeLanguage: ISO language code
 * }
 */

export default ((state = SeamlessImmutable({}), action) => {
  switch (action.type) {
    case REGISTER_STATUS_BAR:
      {
        const {
          contents
        } = action;
        if (!contents) return state;
        return state.merge(contents);
      }

    default:
      return state;
  }
});